/**
 * Ryan O'Dowd
 * 2025-10-16
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Item from './Item';
import {
  Menu as PaperMenu,
} from 'react-native-paper';
import React from 'react';

const Menu = (props: React.ComponentProps<typeof PaperMenu>) => {
  return (
    <PaperMenu
      {...props}
    >
      {props.children}
    </PaperMenu>
  );
};

Menu.displayName = 'Menu';
Menu.Item = Item;
export default Menu;
